var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module__row module__row_scrolled"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }